import React from 'react';
import { sanitizeDescription } from '../../utils/htmlUtils';
import styles from './RichTextContent.module.scss';

const RichTextContent = (props) => {
  const {
    html = '',
    className = '',
  } = props || {};

  return (
    <div
      className={`${styles.content} ${className}`}
      dangerouslySetInnerHTML={{ __html: sanitizeDescription(html) }}
    />
  );
};

export default RichTextContent;